export const TimelineChartContainer = ({
  children,
}: {
  children?: React.ReactNode;
}) => {
  return (
    <div className="h-[398px] rounded-xl bg-dark-container">{children}</div>
  );
};
